import React, { useState } from 'react';

import { productApi as api } from 'api/product';
import { cohortSourceTypeSelectOptions } from 'components/product/utils/cohortDisplay';
import { FormComponent, Notifications } from 'shared';

function CreateCohort() {
    const [notification, setNotification] = useState({ text: null, level: null });

    const formFields = [
        { name: 'name', inputElement: 'textField', label: 'Name', gridValue: 12, inputProps: { required: true } },
        {
            name: 'description',
            inputElement: 'textField',
            label: 'Description',
            gridValue: 12,
            inputProps: { multiline: true, rows: 3 },
        },
        {
            name: 'sourceType',
            inputElement: 'select',
            label: 'Source type (optional)',
            gridValue: 6,
            initialValue: '',
            inputProps: { opts: [...cohortSourceTypeSelectOptions] },
        },
        {
            name: 'sourceRef',
            inputElement: 'textField',
            label: 'Source ref (Braze segment id when source is braze_segment)',
            gridValue: 6,
            inputProps: { placeholder: 'e.g. segment id' },
            display: (formData) => formData.sourceType === 'braze_segment',
        },
    ];

    return (
        <div>
            <h1>Create cohort</h1>
            <Notifications options={notification} />
            {}
            <div style={{ outline: 0, backgroundColor: 'white' }}>
                <FormComponent
                    formFields={formFields}
                    onSubmit={async (formData, resetForm) => {
                        if (formData.sourceType === 'braze_segment' && !String(formData.sourceRef || '').trim()) {
                            setNotification({
                                text: 'Braze segment source requires a source ref (segment id).',
                                level: 'error',
                            });
                            return;
                        }

                        const sendParams = {
                            name: formData.name,
                        };
                        if (formData.description !== undefined && formData.description !== '') {
                            sendParams.description = formData.description;
                        }
                        if (formData.sourceType) {
                            sendParams.sourceType = formData.sourceType;
                        }
                        if (formData.sourceType === 'braze_segment' && String(formData.sourceRef || '').trim()) {
                            sendParams.sourceRef = String(formData.sourceRef).trim();
                        }

                        const response = await api.createCohort(sendParams);
                        if (response.status === true) {
                            setNotification({ text: 'Cohort created', level: 'success' });
                            resetForm();
                        } else {
                            setNotification({
                                text: response?.msg ? `Error: ${response.msg}` : 'Error creating cohort',
                                level: 'error',
                            });
                        }
                    }}
                />
            </div>
        </div>
    );
}

export { CreateCohort };
